module.exports = __webpack_public_path__ + "static/KC1-5dc23f101eab130c54cc7bc412e543a5.png";